import React, { FormEvent, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ButtonLoading } from "go-form";
import handleException from "go-core/api/handleException";
import { ApiError } from "go-core/api/types";
import { api } from "../../../../services/Security/api";
import { useAuth } from "../../../../services/Security/auth";
import { CreateOrganizationApi, RegisterUserApi } from "../../../../services/Security/types";
import { selectIsAuthenticated } from "../../../../services/session/selectors";
import { UserActionTypes } from "../../../../services/users/types";
import AuthenticatedRegisterForm from "./AuthenticatedRegisterForm";
import NonAuthenticatedRegisterForm from "./NonAuthenticatedRegisterForm";

interface Props {
	email?: string;
}

const RegisterForm = (props: Props) => {
	const { t } = useTranslation();
	const auth = useAuth();
	const history = useHistory();
	const [errors, setErrors] = useState<ApiError[]>([]);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const [values, setValues] = useState<RegisterUserApi>({
		user_email: props.email ? props.email : "",
		user_name: "",
		user_password: "",
		user_password_confirmation: "",
		user_phone_number: "",
		accept_rules: false,
		accept_privacy: false,
		accept_user_terms: false,
		accept_organization_terms: false,
		accept_marketing_content: false,
		organization_name: "",
	});
	const [organization, setOrganization] = useState<CreateOrganizationApi>({
		name: "",
		category: null,
		accept_privacy: false,
		accept_terms: false,
		accept_rules: false,
	});

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		setLoading(true);
		try {
			if (!isAuthenticated) {
				await api.registerUser(values);
				await auth.login(values.user_email, values.user_password);
			} else {
				const params: Record<string, any> = {
					include: "applications,applications.accesses,applications.properties",
				};
				const res = await api.user().createOrganization(organization, params);
				dispatch({
					type: UserActionTypes.ADD_ORGANIZATION,
					payload: res.data.data,
				});
				history.push(`/${res.data.data.id}`);
			}
		} catch (e) {
			const exceptionErrors = handleException(e);
			setErrors(exceptionErrors);
			setLoading(false);
		}
	};

	return (
		<Form autoComplete="off" noValidate onSubmit={handleSubmit}>
			{isAuthenticated ? (
				<AuthenticatedRegisterForm
					setValues={setValues}
					setOrganization={setOrganization}
					organization={organization}
					values={values}
					errors={errors}
					loading={loading}
				/>
			) : (
				<NonAuthenticatedRegisterForm errors={errors} loading={loading} values={values} setValues={setValues} />
			)}
			<ButtonLoading loading={loading} type="submit">
				{t("modules.security.action.register.title")}
			</ButtonLoading>
		</Form>
	);
};
export default RegisterForm;
